import { styled as o } from "styled-components";
import { MediaQuery as t } from "../../../styles/variables.js";
import { Icon as e } from "../../../components/Icon/index.js";
import { Colors as a } from "../../../styles/colors/index.js";
import { SmallLight as i, CaptionLight as r } from "../../../styles/typography/index.js";
const f = o.div`
  display: flex;
  align-items: center;
  justify-self: end;
  grid-area: timestamp;

  &[data-keep-mobile-layout='false'] {
    @media ${t.SCREEN_MD_UP} {
      margin-left: 24px;
    }
  }
`, d = o(e)`
  font-size: 24px;
  color: rgb(${a.Gray});
`, c = o.span`
  ${i}
  margin-left: auto;
  padding-bottom: 2px;
  white-space: nowrap;
  color: rgb(${a.Gray});

  &[data-keep-mobile-layout='false'] {
    @media ${t.SCREEN_MD_UP} {
      ${r}
    }
  }
`;
export {
  c as PublishDate,
  f as TimestampArea,
  d as TimestampIcon
};
